// extracted by mini-css-extract-plugin
export default {"heading":"DashboardHeading_heading__eOdtB","content":"DashboardHeading_content__eFMZC","badge":"DashboardHeading_badge__PnP+9","special":"DashboardHeading_special__cYEeD"};